import Button from 'components/form/Button';
import SeachInput from 'components/form/SeachInput';
import Card from 'components/Layout/Card';
import Loader from 'components/Layout/Loader';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { icons } from 'utils/constants';
import './FollowUpTypeManage.scss';
import AddManualFollowUpPopup from './AddManualFollowUpPopup';
import { fetchEventFollowupsStatus, fetchFollowupsList } from 'store/slices';

const FollowUpTypeManage = () => {
  const [followUpsList, setFollowUpsList] = useState([]);
  const dispatch = useDispatch();
  const params = useParams();
  const { eID } = params;
  const navigate = useNavigate();
  const [isopenManualFollowupPopup, setIsopenManualFollowupPopup] =
    useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { userDetails } = useSelector((state) => ({
    userDetails: state.student.userDetails,
  }));

  const [followUpStatus, setFollowUpStatus] = useState({});
  const { create: createAccess, update: updateAccess } =
    userDetails?.role_data?.find(
      (item) => item?.permission_name === 'FollowUp-Discount'
    )?.sub_permission || {};

  const fetchFollowupsData = async () => {
    const response = await dispatch(fetchFollowupsList());
    if (response.status === 200) {
      const formattedData = response.data.followups_list.map(
        (label, index) => ({
          id: index + 1,
          label: label,
        })
      );
      setFollowUpsList(formattedData);
    }
  };

  useEffect(() => {
    fetchFollowupsData();
  }, []);

  const getEventFollowupsStatus = async () => {
    const response = await dispatch(fetchEventFollowupsStatus(eID));
    if (response.status === 200) {
      setFollowUpStatus(response.data.events);
    }
  };

  useEffect(() => {
    getEventFollowupsStatus();
  }, [eID]);

  return (
    <>
      <Card className="followup-type-container cpt-20 cpe-20 cps-20  h-100">
        <div className="d-flex gap-3 cpb-25 border-bottom">
          <div>
            <img
              src={icons.leftArrow}
              alt="back"
              className="h-21 pointer"
              onClick={() => {
                navigate(-1);
              }}
            />
          </div>
          <div className="text-16-500"> {followUpStatus?.event_name}</div>
        </div>
        <div className="row cmt-35">
          <div className="col-md-6">
            <div
              className="text-16-600-20 followup-type"
              onClick={() => {
                if (followUpStatus.event_followups === '0') {
                  setIsopenManualFollowupPopup(true);
                } else {
                  navigate(`/admin/follow-up-discount/${eID}/manual-follow-up`);
                }
              }}
            >
              <img src={icons?.Groups} alt="groups" />
              Manual Follow-Up
            </div>
          </div>
          <div className="col-md-6">
            <div
              className="text-16-600-20 followup-type"
              //   onClick={() => {
              //     handleNavigate('individual');
              //   }}
            >
              <img src={icons?.PersonSearch} alt="person" />
              Segment
            </div>
          </div>
        </div>
      </Card>
      {isopenManualFollowupPopup && (
        <AddManualFollowUpPopup
          onHide={() => setIsopenManualFollowupPopup(false)}
          event_id={eID}
          followUpsList={followUpsList}
        />
      )}
    </>
  );
};

export default FollowUpTypeManage;
